export const selectAdminFeatureState = rootState => rootState.features.admin;
